<template>
    <div class="pagination">
        <button :disabled="currentPage === 1" @click="$emit('page-change', currentPage - 1)" class="page-btn">
            <i class="fas fa-chevron-left"></i>
            Previous
        </button>

        <div class="page-info">
            <span>Page {{ currentPage }} of {{ totalPages }}</span>
            <span class="total-items">Total: {{ totalItems }} {{ itemLabel }}</span>
        </div>

        <button :disabled="currentPage === totalPages" @click="$emit('page-change', currentPage + 1)" class="page-btn">
            Next
            <i class="fas fa-chevron-right"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: 'PaginationWithInfo',
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        },
        totalItems: {
            type: Number,
            required: true
        },
        itemLabel: {
            type: String,
            default: 'items'
        }
    },
    emits: ['page-change']
}
</script>

<style scoped>
.pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    background: #222;
    border-radius: 12px;
}

.page-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.25rem;
    border-radius: 8px;
    border: 1px solid #333;
    background: #1a1a1a;
    color: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
}

.page-btn:not(:disabled):hover {
    background: #2a2a2a;
    border-color: #444;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    color: #666;
}

.total-items {
    font-size: 0.875rem;
}

@media (max-width: 768px) {
    .pagination {
        flex-direction: column;
        gap: 1rem;
    }

    .page-info {
        order: -1;
    }
}
</style>